import React, {useEffect, useMemo, useRef} from 'react';
import Icon, {COLORS, ICONS} from '../icon';
import GRInput from './gr-input';
import { getNumberedFieldName, getUserFriendlyPictureName } from './gr-picture-input';

interface DraggingGrPictureProps {
	fieldName: string;
	options: any;
	variables?: any[];
	values?: Record<string, string>;
	defaultValues?: Record<string, string | object> | undefined;
	count?: number;
}

export default function (props: DraggingGrPictureProps) {
	const {
		fieldName,
		options,
		variables,
		values,
		defaultValues,
		count = 1,
	} = props;

	const [pictureName, setPictureName] = React.useState('preview.png');
	const isUploadedPicture = pictureName !== 'preview.png';

	useEffect(() => {
		setPictureName(getUserFriendlyPictureName(values?.[getNumberedFieldName(fieldName, count)]));
	}, [values]);

	return (
		<div
			className="gr-input-picture dragging"
			key={`picture-${count}`}
			id={`picture-${count}`}
		>
			{!!defaultValues?.oneToManyLabel && (
				<>
					<div className="gr-input-picture-label dragging">
						<div
							className="gr-input-picture-label-drag dragging"
						>
							<Icon
								name={ICONS.DRAG}
								size={12}
								color={COLORS.TEXT_GRAY_500}
							/>
						</div>
						<>
							{defaultValues?.oneToManyLabel ?? 'Picture'}
							&nbsp;
							{count}
						</>
					</div>
				</>
			)}
			<div className="gr-input-picture-fields dragging">
				{(variables?.length ?? 0) > 0 && variables?.map((variable: any) => {
					const fieldName = getNumberedFieldName(variable.userData, count);
					const backUpFieldName = getNumberedFieldName(variable.userData, 2);

					let value = values?.[fieldName] ?? '';
					if (!value && count >= 2 && typeof defaultValues?.[backUpFieldName] === 'string') {
						value = defaultValues?.[backUpFieldName] as string;
					}

					return (
						<GRInput
							key={variable.name}
							fieldName={getNumberedFieldName(variable.userData, count)}
							friendlyName={variable.name}
							fieldType={variable.type}
							onChange={() => {}}
							options={options}
							value={value}
							onFocus={() => {}}
							onBlur={() => {}}
						/>
					)
				})}
			</div>
			<div className="gr-input-picture-row">
				<div
					className="gr-input-picture-thumbnail"
					style={{ backgroundImage: `url(${
							values?.[getNumberedFieldName(fieldName, count)]
							?? defaultValues?.[getNumberedFieldName(fieldName, 2)]
							?? ''
						})`}}
				>
					&nbsp;
				</div>
				<div className="gr-input-picture-name">
					{pictureName}
				</div>
				<div
					className="gr-input-picture-button"
				>
					{!!isUploadedPicture ? 'Replace' : 'Add Image'}
					<Icon
						name={ICONS.CARROT_DOWN}
						size={12}
						color={COLORS.TEXT_GRAY_200}
					/>
				</div>
			</div>
		</div>
	);
}